import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './avatar.component';
import { IconModule } from '../icon/icon.module';
import { BadgeModule } from '../badge/badge.module';

@NgModule({
  declarations: [AvatarComponent],
  imports: [CommonModule, IconModule, BadgeModule],
  exports: [AvatarComponent],
})
export class AvatarModule {}
